import { render, staticRenderFns } from "./CourierChartItem.vue?vue&type=template&id=96031f64&scoped=true&"
import script from "./CourierChartItem.vue?vue&type=script&lang=js&"
export * from "./CourierChartItem.vue?vue&type=script&lang=js&"
import style0 from "./CourierChartItem.vue?vue&type=style&index=0&id=96031f64&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96031f64",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
